export const BLOCKED_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'aol.com',
  'icloud.com',
  'mail.com',
  'protonmail.com',
  'yandex.com',
  'zoho.com',
];

export const TRIAL_SIGNUP_PARAMS = {
  trial_days: '15',
  subscription_type: 'trial',
} as const;

export const SIGNUP_PARAMS = {
  trial_days: '15',
  subscription_type: 'sign-up',
} as const;
